import { tracked } from '@glimmer/tracking';

import type { APIData, GeneralComponentClass } from 'webapp-types';

import CustomQuerySetupPrebuiltFormItemComponent from 'webapp/components/custom-query/setup/prebuilt/item';

import type { CustomMetricSetupFormItem } from 'webapp/models-custom/custom-metric-setup-form/item/group/base';
import CustomMetricSetupFormItemGroupBase from 'webapp/models-custom/custom-metric-setup-form/item/group/base';
import type CustomMetricSetupFormPrebuilt from 'webapp/models-custom/custom-metric-setup-form/prebuilt';

export default class CustomMetricSetupFormItemGroupCommon extends CustomMetricSetupFormItemGroupBase {
	@tracked shownItems: CustomMetricSetupFormItem[] = [];

	constructor(
		groupData: APIData.CustomQuery.Prebuilt.BuilderItem,
		form: CustomMetricSetupFormPrebuilt,
	) {
		super(groupData, form);

		this.isTitle = !groupData.toggleable;
		this.isToggler = !!groupData.toggleable;
	}

	get allFieldsInGroup() {
		return this.shownItems;
	}

	get shownItemsComponent(): GeneralComponentClass {
		return CustomQuerySetupPrebuiltFormItemComponent;
	}

	get isDefault(): boolean {
		return this.items.every((item) => {
			return item.isDefault;
		});
	}

	get valueFormatted(): APIData.CustomQuery.Prebuilt.SettingsData {
		const value: APIData.CustomQuery.Prebuilt.SettingsData = {};

		// flat object with all the fields
		this.shownItems.forEach((item) => {
			if (item.id && !item.isHidden) {
				value[item.id] = item.valueFormatted;
			}
		});

		return value;
	}

	// returns array / object that will be merged into settings sent to BE
	get valueRecord(): APIData.CustomQuery.Prebuilt.SettingsData {
		return this.valueFormatted;
	}

	setInitialValues(_settings: APIData.CustomQuery.Prebuilt.SettingsData): void {
		this.shownItems = this.items;

		// we do not set initial selected bcos title or toggler groups
		// do not have saved settings under their IDs, but instead
		// are merged with the parent settings (see valueRecord)
	}
}
